import axios from 'axios';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`, 
});

axiosInstance.interceptors.request.use(
  config => {
    let bearerToken = localStorage.getItem('token');
    const bearerTokenFromCookies = Cookies.get('token');
    if(bearerTokenFromCookies){
      bearerToken = bearerTokenFromCookies;
      localStorage.setItem('token', bearerTokenFromCookies);
    }
    const apiKey = localStorage.getItem('apiKey');
    if(apiKey){
      config.headers['x-api-key'] = apiKey;
    }
    if (bearerToken) {
      config.headers.Authorization = `Bearer ${bearerToken}`;
    }

    if (config.data) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstance;

